/**
 * Skeleton Component
 *
 * Loading placeholder with shimmer animation.
 *
 * @package PresszoneComments
 */

import { el } from '../utils/dom.js';

/**
 * Render a skeleton loading placeholder.
 *
 * @param {string} type - 'text', 'card', 'stat', 'row'
 * @param {number} count - Number of skeletons
 */
export function Skeleton(type = 'text', count = 1) {
    const items = [];
    for (let i = 0; i < count; i++) {
        switch (type) {
            case 'card':
                items.push(el('div', { class: 'multilingual-skeleton multilingual-skeleton--card' }));
                break;
            case 'stat':
                items.push(el('div', { class: 'multilingual-skeleton multilingual-skeleton--stat' }));
                break;
            case 'row':
                items.push(el('div', { class: 'multilingual-skeleton multilingual-skeleton--row' }));
                break;
            default:
                items.push(el('div', { class: 'multilingual-skeleton multilingual-skeleton--text' }));
        }
    }
    return el('div', { class: 'multilingual-skeleton-wrapper' }, ...items);
}

export default Skeleton;
